(function () {
    'use strict';

    angular.module("imApp").factory("custGrpLangsService", ['$ihttp', function ($ihttp) {
        let service = {
            listCustomerGroupLanguages: function (parms) {
                return $ihttp.post({
                    method: 1007,
                    parameters: parms || {}
                });
            },
            saveObj: function (list) {
                return $ihttp.post({
                    method: 1008,
                    parameters: list
                });
            }
        };

        return service;
    }]);
})();
